import { useDisclosure } from '@chakra-ui/react';
import { useAppSelector } from 'app/store';
import { getShowUpgradePopup, getStorage } from 'app/store/Storage/selectors';
import { setStorageQuotaStatus, showStoragePopUp } from 'app/utils/helpers';
import { useEffect } from 'react';
import { StoragePopUp } from '../StoragePopUp/StoragePopUp';

export const GlobalStoragePopUp = () => {
  const storage = useAppSelector(getStorage);
  const showUpgradePopup = useAppSelector(getShowUpgradePopup);
  const storageOverTheLimitDisclosure = useDisclosure();

  useEffect(() => {
    if (
      showStoragePopUp(
        storage?.quotaStatus,
        storage?.enforceLimit,
        storage?.usedBytesIncreased
      )
    ) {
      storageOverTheLimitDisclosure.onOpen();
    }
    setStorageQuotaStatus(storage?.quotaStatus);
  }, [
    storage?.quotaStatus,
    storage?.enforceLimit,
    storage?.usedBytesIncreased,
    storageOverTheLimitDisclosure,
  ]);

  useEffect(() => {
    if (showUpgradePopup) {
      storageOverTheLimitDisclosure.onOpen();
    }
  }, [storageOverTheLimitDisclosure, showUpgradePopup]);

  return (
    <StoragePopUp
      messageType={showUpgradePopup}
      storageOverTheLimitProps={storageOverTheLimitDisclosure}
    />
  );
};
